import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { intlMessageShape } from 'sb-react-intl'

import Button from 'components/_new/Button/Button'

import s from './Buttons.scss'


const Buttons = ({ leftButton, rightButton }) => (
  <div className={s.buttons}>
    {
      Boolean(leftButton) && (
        <Button
          size="md"
          color="brand"
          dataTestId="dialogModalFirstButton"
          {...leftButton}
          className={cx(s.button, leftButton.className)}
        />
      )
    }
    {
      Boolean(rightButton) && (
        <Button
          size="md"
          color="brand"
          dataTestId="dialogModalSecondButton"
          {...rightButton}
          className={cx(s.button, rightButton.className)}
        />
      )
    }
  </div>
)

Buttons.propTypes = {
  leftButton: PropTypes.shape({
    title: PropTypes.shape(intlMessageShape),
    color: PropTypes.string,
    onClick: PropTypes.func,
    dataTestId: PropTypes.string,
  }),
  rightButton: PropTypes.shape({
    title: PropTypes.shape(intlMessageShape),
    color: PropTypes.string,
    onClick: PropTypes.func,
    dataTestId: PropTypes.string,
  }),
}


export default Buttons
